export function filterPizzasCreme(map) {
  return map.filter((value) => {
    return value.Base_Creme;
  });
}
